const config = {
  routerBase: '/lab-connect',
  backendUrl: 'http://192.168.11.250/lab-connect-api/public/api/',
  siteId: '1',
};

/*
if (process.env.REACT_APP_ENV === 'production') {
  const domainName = 'www.lab-connect.net';
  config.backendUrl = `https://${domainName}/lab-connect/api/public/api/`;
  config.siteId = '1';
}
*/

export default config;
